import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';
import { formatThousands } from '../../utils/fillDynamicText';
import { copyFor, capitalization } from '../../copy/copy';

const Container = styled.div`
    width: 100%;
    font-family: Averta;
    background-color: #fafafa;
    font-weight: bold;
    padding: 20px;
    line-height: 1.3;
    color: #000000;
`;

const QuestionText = styled.h1`
    font-size: 16px;
`;

const NumAnswers = styled.h3`
    font-size: 9px;
    line-height: 16px;
    letter-spacing: 2px;
    color: #c9c3c3;
    font-weight: bold;
`;

const AnswerInfo = styled.h3`
    font-size: 13px;
`;

const SentimentPollMultiSuccess = props => (
    <TransitionContainerNoExit zIndex={15}>
        <Container>
            <QuestionText
                dangerouslySetInnerHTML={{
                    __html: props.questionText
                }}
            />
            <NumAnswers>
                {`${props.noOfAnswers} `}
                {copyFor(
                    'miscellaneous',
                    'numAnswered',
                    'sentimentpoll',
                    capitalization.all
                )}
            </NumAnswers>
            <AnswerInfo>{`${props.feedbackText}`}</AnswerInfo>
        </Container>
    </TransitionContainerNoExit>
);

SentimentPollMultiSuccess.propTypes = {
    feedbackText: PropTypes.string.isRequired,
    noOfAnswers: PropTypes.string.isRequired,
    questionText: PropTypes.string.isRequired
};

export default connect(
    state => {
        return {
            feedbackText: state.sentimentPoll.feedbackText,
            noOfAnswers: formatThousands(state.sentimentPoll.noOfAnswers),
            questionText: state.sentimentPoll.questionText,
            resultDistribution: state.sentimentPoll.resultDistribution,
            sentimentValue: state.sentimentPoll.sentimentValue
        };
    },
    {}
)(SentimentPollMultiSuccess);
